<template>
    <ModelCreateLayout
        :indexRoute="$route('admin::projects.index')"
        :storeRoute="$route('admin::projects.store')"
        :modelNameSingular="__('admin::projects.project')"
        :modelNamePlural="__('admin::projects.projects')"
        :form="form"
    >

        <h2 class="text-lg font-bold mb-2">
            {{ __('admin::projects.master_data') }}
        </h2>

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" :allow-empty="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.department')" :error="errors.department_id">
            <Select name="department_id" :options="departmentOptions" :has-error="exists(errors.department_id)" v-model="form.department_id" :required="true" :allow-empty="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.type')" :error="errors.type">
            <Select name="type" :options="typeOptions" :has-error="exists(errors.type)" v-model="form.type" :required="true" :allow-empty="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.status')" :error="errors.status">
            <Select name="status" :options="statusOptions" :has-error="exists(errors.status)" v-model="form.status" :required="true" :allow-empty="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.case_material')" :error="errors.case_material">
            <FileLinkInput v-model="form.case_material" />
        </FormGroup>

        <FormGroup class="space-y-2">
            <Toggle name="is_active" v-model:checked="form.is_active" :label="__('admin::labels.is_active')" />
            <Toggle name="show_on_united_site" v-model:checked="form.show_on_united_site" :label="__('admin::labels.show_on_united_site')" />
            <Toggle name="in_active_operation" v-model:checked="form.in_active_operation" :label="__('admin::labels.in_active_operation')" />
            <Toggle name="delete_manually_created_posts" v-model:checked="form.delete_manually_created_posts" :label="__('admin::labels.delete_manually_created_posts')" />
        </FormGroup>

        <h2 class="text-lg font-bold mb-2 mt-2">
            {{ __('admin::projects.location') }}
        </h2>

        <FormGroup :label="__('admin::labels.address')">
            <Input name="address" type="text" v-model="form.address" :required="false" />
        </FormGroup>

        <div class="grid grid-cols-3 gap-4">
            <FormGroup :label="__('admin::labels.zipcode')" :error="errors.zipcode">
                <Input name="zipcode" type="text" :has-error="exists(errors.zipcode)" v-model="form.zipcode" :required="false" />
            </FormGroup>

            <FormGroup :label="__('admin::labels.city')" :error="errors.city">
                <Input name="city" type="text" :has-error="exists(errors.city)" v-model="form.city" :required="false" />
            </FormGroup>

            <FormGroup :label="__('admin::labels.country')" :error="errors.country">
                <Select name="country" :options="countryOptions" :has-error="exists(errors.country)" v-model="form.country" :required="false" />
            </FormGroup>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <FormGroup :label="__('admin::labels.latitude')" :error="errors.latitude">
                <Input name="latitude" type="number" step="any" :has-error="exists(errors.latitude)" v-model="form.latitude" :required="false" />
            </FormGroup>

            <FormGroup :label="__('admin::labels.longitude')" :error="errors.longitude">
                <Input name="longitude" type="number" step="any" :has-error="exists(errors.longitude)" v-model="form.longitude" :required="false" />
            </FormGroup>
        </div>

        <h2 class="text-lg font-bold mb-2 mt-2">
            {{ __('admin::projects.united_site') }}
        </h2>

        <FormGroup :label="__('admin::labels.short_description')" :error="errors.short_description">
            <Textarea name="short_description" :has-error="exists(errors.short_description)" v-model="form.short_description" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.external_site_link')" :error="errors.external_site_link">
            <Input name="external_site_link" type="text" :has-error="exists(errors.external_site_link)" v-model="form.external_site_link" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.featured_image')" :error="errors.featured_image_id">
            <AdvancedFileInput v-model="form.featured_image_id" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.gallery_images')" :error="errors.gallery_image_ids">
            <AdvancedFileInput v-model="form.gallery_image_ids" multiple />
        </FormGroup>

    </ModelCreateLayout>
</template>

<script>
import ModelCreateLayout from '@/Layouts/ModelCreateLayout'
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Select from "@/Components/Select";
import Toggle from "@/Components/Toggle";
import Textarea from "@/Components/Textarea";
import AdvancedFileInput from "@/Components/AdvancedFileInput";
import FileLinkInput from "@/Components/FileLinkInput.vue";

export default {
    components: {
        FileLinkInput,
        AdvancedFileInput,
        Textarea,
        Toggle,
        Select,
        Input,
        FormGroup,
        ModelCreateLayout,
    },
    props: {
        errors: Object,
        departmentOptions: Object,
        typeOptions: Object,
        statusOptions: Object,
        countryOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                department_id: Object.keys(this.departmentOptions)[0],
                type: Object.keys(this.typeOptions)[0],
                status: Object.keys(this.statusOptions)[0],
                case_material: null,
                is_active: true,
                show_on_united_site: true,
                in_active_operation: true,
                delete_manually_created_posts: true,
                address: '',
                zipcode: '',
                city: '',
                country: 'DK',
                latitude: '',
                longitude: '',
                short_description: null,
                external_site_link: null,
                featured_image_id: null,
                gallery_image_ids: [],
            })
        }
    },
}
</script>
